import { render, staticRenderFns } from "./DaftarUmkmView.vue?vue&type=template&id=596c75c5&scoped=true"
import script from "./DaftarUmkmView.vue?vue&type=script&lang=js"
export * from "./DaftarUmkmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c75c5",
  null
  
)

export default component.exports